import { useContext } from "react";

import ParamsContext from "context/params/paramsContext";
import { getStringifiedParams } from "shared/functions";
import { FILTER_NAMES } from "shared/types/enums";

const useGetFilterParams = () => {
    const { queryParams } = useContext(ParamsContext);

    const getFilterParams = () => {
        const rootParams = queryParams[FILTER_NAMES.RootCompany] as string;
        const companyIdParams = queryParams[FILTER_NAMES.CompanyId];

        return {
            [FILTER_NAMES.RootCompany]: rootParams,
            [FILTER_NAMES.CompanyId]: companyIdParams || ""
        };
    };

    const filterParams = getFilterParams();
    const stringifiedFilterParams = getStringifiedParams(filterParams);

    return { filterParams, stringifiedFilterParams };
};

export { useGetFilterParams };
